
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumb_list: Array,
  },
  data() {
    return {
      referrer: null,
    }
  },

  created() {
    this.scrollToEndOfBreadcrumb()
  },
  watch: {
    breadcrumb_list() {
      this.scrollToEndOfBreadcrumb()
    },
  },
  methods: {
    scrollToEndOfBreadcrumb() {
      if (process.client && this.$device.isMobile) {
        setTimeout(() => {
          let bredcrumb = document.getElementsByClassName('breadcrumb')
          bredcrumb[1]
            ? (bredcrumb[1].scrollLeft = bredcrumb[1].scrollWidth)
            : null
        }, 600)
      }
    },
    goBack() {
      window.history.back()
    },
  },
}
